var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeedbackIcon = function SvgFeedbackIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.5C13.5523 0.5 14 0.947715 14 1.5V10.5C14 11.0523 13.5523 11.5 13 11.5H6.86992L3.65079 14.2593C3.35428 14.5134 2.93694 14.5717 2.58214 14.4085C2.22734 14.2453 2 13.8905 2 13.5V11.5H1C0.447715 11.5 0 11.0523 0 10.5V1.5C0 0.947715 0.447715 0.5 1 0.5H13ZM12 2.5H2V9.5H3C3.55228 9.5 4 9.94772 4 10.5V11.3258L5.84921 9.74074C6.03045 9.58539 6.26129 9.5 6.5 9.5H12V2.5ZM4 7C4.55229 7 5 6.55228 5 6C5 5.44772 4.55229 5 4 5C3.44771 5 3 5.44772 3 6C3 6.55228 3.44771 7 4 7ZM8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6ZM10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedbackIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedbackIcon.af76ff7a.svg";
export { ForwardRef as ReactComponent };